import { useMemo } from 'react'

/**
 * Custom hook to group clinic locations by their brand
 * @param {Object} params
 * @param {Array} params.mentorClinicAssociationData - Array of clinic associations
 * @returns {Object} - Returns clinicLocationOptions (grouped by brand) and clinicBrands
 */
export default function useClinicLocationsByBrand({
  mentorClinicAssociationData,
}) {
  const clinicBrands = useMemo(() => {
    const clinicBrandIdToClinicBrandMap = {}
    mentorClinicAssociationData?.forEach((association) => {
      if (association?.clinicBrandId) {
        clinicBrandIdToClinicBrandMap[association.clinicBrandId] = {
          id: association.clinicBrandId,
          clinicBrandName: association.clinicBrandName,
        }
      }
    })
    return Object.values(clinicBrandIdToClinicBrandMap)
  }, [mentorClinicAssociationData])

  const clinicLocationOptions = useMemo(() => {
    return clinicBrands?.map((clinicBrand) => ({
      label: clinicBrand?.clinicBrandName || clinicBrand?.title || '--',
      options: mentorClinicAssociationData?.filter(
        (association) => association?.clinicBrandId === clinicBrand?.id,
      ),
    }))
  }, [mentorClinicAssociationData, clinicBrands])

  return {
    clinicLocationOptions,
    clinicBrands,
  }
}
